export const SessionStructure = {
  primary: {
    name: 'Standard Terms',
    description: '3 terms per session',
    is_default: true,
  },
  secondary: {
    name: 'Standard Terms',
    description: '3 terms per session',
    is_default: true,
  },
  tertiary: {
    name: 'Standard Semesters',
    description: '2 semesters per session',
    is_default: true,
  },
};

export const TermStructure = {
  primary: [
    { name: '1st Term', sequence: 1 },
    { name: '2nd Term', sequence: 2 },
    { name: '3rd Term', sequence: 3 },
  ],
  secondary: [
    { name: '1st Term', sequence: 1 },
    { name: '2nd Term', sequence: 2 },
    { name: '3rd Term', sequence: 3 },
  ],
  tertiary: [
    { name: '1st Semester', sequence: 1 },
    { name: '2nd Semester', sequence: 2 },
  ],
};
